import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=010ea405&scoped=true"
import script from "./SortableItem.vue?vue&type=script&lang=js"
export * from "./SortableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ea405",
  null
  
)

export default component.exports